//https://github.com/greim/html-tokenizer

import Tokenizer from '../tokenizer/index'
import EventEmitter from '../share/EventEmitter'

import isSelfClosing from './isSelfCloseing'
import isClosedBy from './isClosedBy'
import isClosedByParent from './isClosedByParent'

import makeStack from './makeStack'

export default class extends EventEmitter {
  constructor(opts = {}) {
    super()

    this._stack = null

    let tkzr = this._tokenizer = new Tokenizer(opts)
      , pendingTag

    tkzr.on("start", () => {
      this.emit("start")
    })

    tkzr.on("opening-tag", name => {
      pendingTag = {
        name,
        attributes: {}
      }
    })

    tkzr.on('closing-tag', name => {
      // @ts-ignore
      var current = this._stack.peek()
        // @ts-ignore
        , parent = this._stack.peek(1)
      if (current) {
        if (current.name === name) {
          this._stack.pop()
          this.emit('close', current.name, false)
        } else {
          if (parent && parent.name === name && isClosedByParent(current.name)) {
            this._stack.pop()
            this.emit('close', current.name, false)
            this._stack.pop()
            this.emit('close', parent.name, false)
          }
        }
      }
    })

    tkzr.on('opening-tag-end', (name, token) => {
      // @ts-ignore
      var mightBeClosed = this._stack.peek()
        , isSelfClose = token === '/>' || isSelfClosing(name)
      if (mightBeClosed && isClosedBy(mightBeClosed.name, pendingTag.name)) {
        this._stack.pop()
        this.emit('close', mightBeClosed.name, false)
      }
      this.emit('open', pendingTag.name, pendingTag.attributes, isSelfClose)
      if (isSelfClose) {
        this.emit('close', pendingTag.name, true)
      } else {
        this._stack.push(pendingTag)
      }
    })
    // ----------------------
    tkzr.on('text', value => {
      this.emit('text', value)
    })
    // ----------------------
    tkzr.on('comment', value => {
      this.emit('comment', value)
    })
    // ----------------------
    tkzr.on('attribute', (name, value) => {
      pendingTag.attributes[name] = value
    })
  }

  parse(html) {
    this._stack = makeStack()
    this._tokenizer.tokenize(html)
    while (this._stack.length > 0) {
      var next = this._stack.pop()
      this.emit('close', next.name, false)
    }
    delete this._stack
    this.emit('done')
  }
}



// WEBPACK FOOTER //
// ./src/common/components/process-editor/modules/dinnerSvg/parser/index.js